import util from 'static/script/app/ui/checkout2/context/util';
import 'braintree';

function PaymentMethod(type, paypalEmail, nonce, token, isSelected, isNewCard) {
    this.type = type;
    this.paypalEmail = paypalEmail;
    this.nonce = nonce;
    this.token = token;
    this.isNewCard = isNewCard;
    this.isSelected = isSelected;
    this.cardValidation = {};
    this.saveCard = false;

    this.getId = function() { return this.token ? this.token : this.nonce; };

    this.isDeletable = function() { return this.token !== null; };

    this.isValid = function() {
        if (this.isNewCard) {
            return this.cardValidation.number && this.cardValidation.expirationDate && this.cardValidation.cvv;
        }

        return true;
    };

    this.reset = function () {
        if (isNewCard) {
            this.cardValidation = {};
            this.nonce = null;
            this.token = null;
        }
    };

    this.isCard = function () {
        return this.type === 'card';
    };
}

let context;
let deviceData;
let model;
let selectedPaymentType;
let paymentMethods;
let newCard = new PaymentMethod('card', null, null, null, false, true);

function getCards() {
    return paymentMethods.filter(function (item) { return item.type === 'card'; });
}

function getPaypalAccounts() {
    return paymentMethods.filter(function (item) { return item.type === 'paypal'; });
}

function selectPaymentMethod(payment) {
    if (!payment && selectedPaymentType === 'paypal') {
        context.observable.trigger('payment-not-valid');
        return;
    }

    if (!payment) {
        payment = newCard;
    }

    if (selectedPaymentType === 'card') {
        getCards().forEach(function (item) { item.isSelected = false; });
    } else {
        getPaypalAccounts().forEach(function(item) { item.isSelected = false; });
    }

    payment.isSelected = true;

    if (payment.isValid()) {
        context.observable.trigger('payment-valid');
    } else {
        context.observable.trigger('payment-not-valid');
    }
}

function getSelectedPaymentMethod() {
    let result = paymentMethods.filter(function (item) { return item.isSelected && item.type === selectedPaymentType; });

    if (result.length === 0) {
        return null;
    } else {
        return result[0];
    }
}

function getSubmitPayload() {
    let selected = getSelectedPaymentMethod();
    return {
        deviceData: deviceData,
        token: selected.token,
        nonce: selected.nonce,
        saveCard: selected.saveCard
    };
}

function getPreselectedPaymentMethod() {
    let selectedMethods = paymentMethods.filter(function (item) { return item.isSelected; });

    return selectedMethods.length === 0 ? null : selectedMethods[0];
}

function prepareCard(nonce) {
    let card = getSelectedPaymentMethod();
    console.log('card prepared: isCard=' + card.isCard() + ' isNewCard=' + card.isNewCard);
    card.nonce = nonce;
    context.observable.trigger('braintree-payment-ready-for-submit', getSubmitPayload());
}

module.exports = {
    init: function(modelIn, contextIn) {

        context = contextIn;
        model = modelIn;
        let tempPaymentMethods = [];
        model.paymentMethods.forEach(function (item) { tempPaymentMethods.push($.extend(new PaymentMethod(), item)); });

        paymentMethods = tempPaymentMethods;
        paymentMethods.push(newCard);

        let preselectedPaymentMethod = getPreselectedPaymentMethod();

        if (!preselectedPaymentMethod) {
            newCard.IsSelected = true;
        }
        else {
            this.selectPaymentType(preselectedPaymentMethod.type);
        }
    },

    selectedPaymentType: function () { return selectedPaymentType; },

    saveNewCardOnPayment: function(save) {
        newCard.saveCard = save;
    },

    cards: getCards,

    paypalAccounts: getPaypalAccounts,

    setDeviceData: function (deviceDataIn) {
        deviceData = deviceDataIn;
    },

    prepareForSubmit : function() {
        let selectedMethod = getSelectedPaymentMethod();

        if (!selectedMethod) {
            context.observable.trigger('braintree-payment-not-ready-for-submit');
            return false;
        }

        if (selectedMethod.isNewCard) {
            return false;
        }

        if (selectedMethod.isCard()) {
            context.observable.trigger('braintree-verify-3d-secure', selectedMethod.nonce);
            return true;
        }
        else {
            context.observable.trigger('braintree-payment-ready-for-submit', getSubmitPayload());
            return true;
        }
    },

    selectPaymentMethod: selectPaymentMethod,

    setShippingCost: function(cost) {
        model.shippingCost = cost;
    },

    getPaymentAmount: function() {
        return model.itemPrice + model.shippingCost;
    },

    deletePaymentMethod: function(item) {
        let defered = $.Deferred();

        let onPaymentMethodDeleted = function(item) {
            let index = paymentMethods.indexOf(item);
            paymentMethods.splice(index, 1);
            this.selectPaymentType(selectedPaymentType);
            defered.resolve();
        };

        let onError = function(req, status, error) {
            console.warn('failed to delete payment method');
            util.serverLog({ error: 'Failed to delete braintree payment method: ' + error, counterName: 'braintree-payment.delete-method-failed' });
        };

        $.ajax({
            type: 'POST',
            url: '/shopping/checkout2/deletebraintreepaymentmethod/',
            data: { token: item.token },
            success: onPaymentMethodDeleted.bind(this, item),
            error: onError
        });

        return defered.promise();
    },

    isBraintreePaymentType: function(type) {
        return type === 'card' || type === 'paypal';
    },
    selectPaymentType: function(type) {
        selectedPaymentType = type;

        if (!this.isBraintreePaymentType(type)) {
            return;
        }

        let selectedPaymentMethod = getSelectedPaymentMethod();

        if (selectedPaymentMethod) {
            selectedPaymentMethod.reset();
        }

        selectPaymentMethod(selectedPaymentMethod);
        context.observable.trigger('payment-type-selected', type);
    },

    addNewPaypalAccount: function (nonce, email) {
        let addedPaypalMethod = new PaymentMethod('paypal', email, nonce, null, true);
        paymentMethods.push(addedPaypalMethod);
        selectPaymentMethod(addedPaypalMethod);
    },

    prepareCard: prepareCard,

    processCardError: function(error) {
        newCard.nonce = null;

        context.observable.trigger('braintree-payment-not-ready-for-submit');

        if (error.type !== 'VALIDATION') {
            console.warn('braintree error: ' + error.message);
            util.serverLog({ error: 'Braintree ' + error.type + ' error: ' + error.message, counterName: 'braintree-payment.integration-error.' + error.type });
        }
    },

    validateNewCard: function(field, isValid) {

        newCard.cardValidation[field] = isValid;

        if (newCard.isValid()) {
            context.observable.trigger('payment-valid');
        } else {
            context.observable.trigger('payment-not-valid');
        }
    },

    validate3DSecureResult: function (error, response) {
        if (error) {
            //this.failureResolutionCode = 'TryAgain';
            context.observable.trigger('braintree-payment-not-ready-for-submit');
            util.serverLog({ error: 'Card 3DSecure error: ' + error.message, counterName: 'braintree-payment.card-3dsecure.error' });

        } else if (response.verificationDetails.liabilityShiftPossible && !response.verificationDetails.liabilityShifted) {
            //this.failureResolutionCode = '3DSecureFailed';
            context.observable.trigger('braintree-payment-not-ready-for-submit');
            util.serverLog({ counterName: 'braintree-payment.card-3dsecure.unsuccessful' });
        } else {
            prepareCard(response.nonce);
            util.serverLog({ counterName: 'braintree-payment.card-3dsecure.successful' });
        }
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/braintree-payment-core.js